<template>
  <div>
    <div class="header">
      <h3>Penilaian Manajemen</h3>
    </div>

    <div class="body">
      <div class="tabs">
        <ul>
          <li :class="{ active: tab == 'penilaian' }" @click="tab = 'penilaian'">Penilaian Manajemen</li>
          <li :class="{ active: tab == 'saran' }" @click="tab = 'saran'">Kritik & Saran</li>
        </ul>
      </div>

      <div class="tab-body">
        <div class="grid">
          <div>
          </div>
          <div>
            <select v-model="param.kampus">
              <option value="1">PSPP Lampung</option>
              <option value="2">PSPP Jakarta</option>
              <option value="3">PSPP Yogyakarta</option>
              <option value="5">PSPP Makassar</option>
              <option value="6">PSPP Bali</option>
            </select>
          </div>
        </div>

        <div v-show="tab == 'penilaian'">
          <ul class="manajemen">
            <li v-for="item, index in data.filter((k) => k.id_kampus == param.kampus)" :key="index">
              <div>
                <img :src="item.foto || 'https://img.icons8.com/?size=50&id=12438&format=png'" height="100%">
              </div>
              <div>
                <p>{{ item.nama }}</p>
                <small>{{ item.jabatan }}</small>
              </div>
              <div>
                <span class="rating">{{ item.rating }}</span>
              </div>
            </li>
          </ul>
        </div>

        <div v-show="tab == 'saran'">
          <ul>
            <li v-for="item, index in dataSaran.filter((k) => k.id_kampus == param.kampus)" :key="index">
              <p>
                {{ item.kritik_saran }}
              </p>
            </li>
          </ul>
        </div>

      </div>
      <div class="skeleton-wrapper" v-show="loading">
        <div class="skeleton" v-for="(item, index) in [1, 1, 1, 1, 1]" :key="index"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "./../api/Api";

export default {
  data() {
    return {
      loading: false,

      tab: 'penilaian',
      param: {
        kampus: 3
      },

      data: [],
      dataSaran: [],
      dataKampus: {
        1: 'PSPP Lampung',
        2: 'PSPP Jakarta',
        3: 'PSPP Yogyakarta',
        5: 'PSPP Makassar',
        6: 'PSPP Bali',
      }
    }
  },
  methods: {
    async load() {
      this.loading = true;

      const res = await api.get('/v1/kendali_kerja/penilaian_manajemen/get');
      this.data = res.data
      this.dataSaran = res.saran

      this.data.forEach((item) => {
        item.rating =
          Math.round(item.rating * 100) / 100
      })

      this.loading = false;
    },
    detail(item) {
      setTimeout(() => {
        this.$router.push('/penilaian-manajemen/' + item.id)
      }, 150)
    }
  },
  mounted() {
    this.load();
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  z-index: 2;
  top: 0;
  left: calc(50% - 240px);
  width: 440px;
  display: flex;
  gap: 10px;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 15px 20px;
  background: #fff;

  @media screen and (max-width: 768px) {
    left: 0;
    width: 100%;
  }

  h3 {
    margin: 0;
  }

  .icon {
    height: 26px;
    display: flex;
    align-items: center;
  }
}

.body {
  padding: 20px;
  padding-top: 60px;
  padding-bottom: 100px;

  .tabs {
    ul {
      list-style: none;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      padding: 0;

      li {
        padding: 10px 20px;
        border-bottom: 1px solid #ccc;
        text-align: center;
        cursor: pointer;
        font-size: 14px;

        &.active {
          border-bottom: 2px solid var(--primary);
          color: var(--primary);
        }
      }
    }
  }

  .manajemen {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: grid;
      grid-template-columns: 60px 1fr 40px;
      gap: 10px;
      margin-bottom: 20px;

      >div {
        &:last-child {
          display: flex;
          align-items: center;
        }
      }

      img {
        width: 60px;
        height: 80px;
        object-fit: cover;
        object-position: center;
      }

      p {
        margin-bottom: 0;
        font-weight: bold;
      }

      span {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        background-color: gold;
        border-radius: 40px;
        width: 40px;
        height: 40px;
        font-weight: bold;
      }
    }
  }

  .grid {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.skeleton-wrapper {
  margin-top: 20px;

  .skeleton {
    min-height: 65px;
    border-radius: 4px;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PenilaianManajemen.vue